import BusyIndicator from "../../BusyIndicator/index";
import ToolTip from "../../ToolTip/index";
import * as React from "react";
import styles = require("./style.less");
import FormFieldProps from "components/form/FormFieldProps";
import Select from "components/form/Select/Select";
import { AccountResource, AccountType } from "client/resources/accountResource";
import CloudIcon from "material-ui/svg-icons/file/cloud"; //https://material.io/icons/#ic_cloud
import LockIcon from "material-ui/svg-icons/action/lock"; //https://material.io/icons/#ic_lock
import PersonIcon from "material-ui/svg-icons/social/person"; //https://material.io/icons/#ic_person
import Note from "components/form/Note/Note";
import {Icon, default as IconButton} from "components/IconButton/IconButton";
import IconButtonList from "components/IconButtonList/IconButtonList";
import routeLinks from "routeLinks";
import InputWithActions from "components/InputWithActions/InputWithActions";

interface AccountSelectProps extends FormFieldProps<string> {
    multiple?: boolean;
    fixedLabel?: boolean;
    type: AccountType | AccountType[];
    items: AccountResource[];
    hintText?: string;
    allowClear?: boolean;
    disabled?: boolean;
    label?: string | JSX.Element;
    error?: string;
    warning?: string;
    validate?(value: string): string;
    onValidate?(value: string): void;
    onRequestRefresh(): Promise<any>;
}

interface TextState {
    error?: string;
    refreshing: boolean;
}

export default class AccountSelect extends React.Component<AccountSelectProps, TextState> {

    constructor(props: AccountSelectProps) {
        super(props);
        this.state = {
            error: null,
            refreshing: false
        };
    }

    handleChange = (accountId: string) => {
        const value = accountId === "" ? null : accountId;
        if (this.props.validate) {
            const result = this.props.validate(value);
            this.setState({ error: result });
            if (this.props.onValidate) {
                this.props.onValidate(result);
            }
        }
        this.props.onChange(value);
    }

    getIcon(type: AccountType) {
        switch (type) {
            case AccountType.AzureServicePrincipal:
            case AccountType.AzureSubscription:
                return <CloudIcon />;
            case AccountType.SshKeyPair:
                return <LockIcon />;
            case AccountType.UsernamePassword:
                return <PersonIcon />;
        }
    }

    getItems() {
        const map = (acc: AccountResource) => ({ value: acc.Id, text: acc.Name, icon: this.getIcon(acc.AccountType) });
        const types = (Array.isArray(this.props.type)) ? this.props.type : [this.props.type];

        return this.props.items.filter(a => types.find(t => a.AccountType === t)).map(map);
    }

    selectionRenderer = (accountId: string) => {
        const account = this.props.items.find(acc => acc.Id === accountId);
        if (!account) {
            return accountId;
        }
        return <div className={styles.innerContainer}>
            <span className={styles.selectedIcon}>{this.getIcon(account.AccountType)}</span> {account.Name}
        </div>;
    }

    onlyTypeIs(type: string) {
        const types = (Array.isArray(this.props.type)) ? this.props.type : [this.props.type];
        return types.length === 1 && types[0] === type;
    }

    render() {
        const {
            items,
            onChange,
            onValidate,
            onRequestRefresh,
            ...otherProps
        } = this.props;

        let warning = "";
        if (this.onlyTypeIs(AccountType.AzureSubscription)) {
            warning = "Only Azure management-certificate accounts may be selected.";
        }

        if (this.onlyTypeIs(AccountType.AzureServicePrincipal)) {
            warning = "Only Azure service principal accounts may be selected.";
        }

        return (
            <div className={styles.outerContainer}>
                <InputWithActions input={<Select
                            label="Select account"
                            {...otherProps}
                            allowFilter={true}
                            onChange={this.handleChange}
                            error={this.state.error || this.props.error}
                            items={this.getItems()}
                            selectionRenderer={this.selectionRenderer}
                        />}
                    actions={<IconButtonList buttons={this.buttons()}/>} />
                {warning && <Note>{warning}</Note>}
            </div>
        );
    }

    private goToAccounts = () => {
        window.open(`#${routeLinks.infrastructure.accounts.root}`, "_blank");
    }

    private onRequestRefresh = async () => {
        this.setState({ refreshing: true });
        try {
            await this.props.onRequestRefresh();
        } finally {
            this.setState({ refreshing: false });
        }
    }

    private buttons() {
        return [this.state.refreshing
            ? <BusyIndicator show={true} inline={true}/>
            : <IconButton onClick={this.onRequestRefresh} toolTipContent="Refresh" icon={Icon.Refresh}/>,
            <IconButton toolTipContent="Add" onClick={this.goToAccounts} icon={Icon.Add}/>];
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/AccountSelect/AccountSelect.tsx